export enum CodeEditorStatus {
  Default = 'default',
  Success = 'success',
  Error = 'error',
}

export interface SchemaErrorMessages {
  [key: string]: string;
}

export interface EditorSchemaObject {
  [key: string]: unknown;
  errorMessage?: SchemaErrorMessages;
  title?: string;
  description?: string;
}

export type TextTranslateFunction = (key: string, params?: Record<string, string | number>) => string;

export interface ModelErrorPattern {
  key: string;
  regex: RegExp;
  params: (match: RegExpMatchArray, message: string) => Record<string, string | number>;
}
